interface AppConfig {
  appId: string;
  displayName: string;
  subtitle?: string;
  oneLinkUrl: string;
  logoUrl: string;
  description?: string;
}

interface PartnerConfig {
  partnerId: string;
  displayName: string;
  oneLinkUrl?: string;
  logoUrl?: string;
  description?: string;
}

export const APPS: Record<string, AppConfig> = {
  calio: {
    appId: 'diet-tracker',
    displayName: 'Vitl Tracker',
    subtitle: 'Calio is now Vitl Tracker',
    oneLinkUrl: 'https://trackerapp.vitl.com/iRjl',
    logoUrl: '/images/app-code-redemption/app/vitl-ai-calorie-tracker-40@3x.png',
    description: 'Track calories with AI'
  },
  vitltracker: {
    appId: 'diet-tracker',
    displayName: 'Vitl Tracker',
    subtitle: 'Calio is now Vitl Tracker',
    oneLinkUrl: 'https://trackerapp.vitl.com/iRjl',
    logoUrl: '/images/app-code-redemption/app/vitl-ai-calorie-tracker-40@3x.png',
    description: 'Track calories with AI'
  },
  // Add more apps here as needed
};

export const PARTNERS: Record<string, PartnerConfig> = {
  perkbox: {
    partnerId: 'perkbox_uk',
    displayName: 'Perkbox',
    oneLinkUrl: 'https://trackerapp.vitl.com/iRjl/jngfhmoc',
    logoUrl: '/images/app-code-redemption/partner/perkbox.png',
    description: 'Employee benefits'
  },
  betterspace: {
    partnerId: 'betterspace_uk',
    displayName: 'Better Space',
    oneLinkUrl: 'https://trackerapp.vitl.com/iRjl/s8g3vthn',
    logoUrl: '/images/app-code-redemption/partner/better-space.webp',
    description: 'Employee benefits'
  },
  heka: {
    partnerId: 'heka_uk',
    displayName: 'Heka',
    oneLinkUrl: 'https://trackerapp.vitl.com/iRjl/qs36unyl',
    logoUrl: '/images/app-code-redemption/partner/heka.webp',
    description: 'Employee benefits'
  }
  // Add more partners here as needed
};

// Normalize URL path by converting to lowercase and removing hyphens
const normalizePath = (path: string): string => {
  return path.toLowerCase().replace(/-/g, '');
};

export const getAppConfig = (urlPath: string): AppConfig | undefined => {
  return APPS[normalizePath(urlPath)];
};

export const getPartnerConfig = (urlPath: string): PartnerConfig | undefined => {
  return PARTNERS[normalizePath(urlPath)];
}; 